import React from "react";
import "../../../../styles/Pages/Operational/Academic/Teachers/Teachers.style.css";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { Helmet } from "react-helmet";
import SearchIcon from "../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import profileImg from "../../../../assets/Images/TestImg/profileImage.png";
import StaffsHeadCard from "../../../../components/PagesComponents/UniversalComponents/StaffsHeadCard.component";
import IndivisualMemberCard from "../../../../components/PagesComponents/Organizational/Management/Members/IndivisualMemberCard.component";
import MemberListCard from "../../../../components/PagesComponents/Organizational/Management/Members/MemberListCard.component";
import { Formik } from "formik";
import Modal from "../../../../components/Universal/Modal.component";
import DropDownInput from "../../../../components/Universal/DropDownInput.component";
import ToggleBtn from "../../../../components/Universal/ToggleBtn.component";
import DatePicker from "../../../../components/Universal/DatePicker.component";
import MemberFormValidation from "../../../../components/PagesComponents/Organizational/Management/Members/MemberFormValidation.component";
import FormInput from "../../../../components/Universal/FormInput.component";
import FileInput from "../../../../components/PagesComponents/Organizational/Management/Members/FileInput.component";
const Body = ({ addMemberModal, setAddMemberModal }) => {
  // const [submittedValues, setSubmittedValues] = useState(null); // State to store submitted values
  const suggestions = [
    "Apple",
    "Apple",
    "Banana",
    "Cherry",
    "Date",
    "Elderberry",
  ];
  return (
    <section className="teachersSection">
      <Helmet>
        <title>Teachers</title>
      </Helmet>
      <PageHeader
        renderCustomElement={
          <div className="flex-col g-05 align-start justify-end">
            <div className="searchInputContainer">
              <input
                type="text"
                className="pageHeaderInput"
                placeholder="Type for search"
              />
              <button className="searchBtn">
                <img src={SearchIcon} alt="searchBtn" />
              </button>
            </div>
          </div>
        }
      />
      <Modal isOpen={addMemberModal} onClose={() => setAddMemberModal(false)}>
        <Formik
          initialValues={{
            name: "",
            phone: "",
            email: "",
            designation: "",
            joiningDate: "",
            maritalStatus: "",
            workingField: "",
            gender: "",
            salary: "",
            reportingTo: "",
            bloodGroup: "",
            experience: "",
            experienceField: "",
            address: "",
            aadhaarNumber: "",
            photoCopy: null,
            signature: null,
            positionColor: "",
          }}
          validationSchema={MemberFormValidation} // Validation schema
          onSubmit={(values) => {
            console.log("Form Submitted:", values); // Log the values
            // setSubmittedValues(values); // Store the submitted values in state
          }}
        >
          {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => {
            console.log(errors);

            return (
              <form onSubmit={handleSubmit} className="memberForm">
                <div className="memberAddFormLeft">
                  <h3 className="addNewMembersFormTitle">Add teachers</h3>
                  <div className="addNewMembersLeftInputs">
                    {/* Additional fields or instructions can go here */}

                    <DropDownInput
                      type="color"
                      name="positionColor"
                      label="Position Color"
                      setFieldValue={(val) =>
                        setFieldValue("positionColor", val)
                      }
                      placeholder={"Choose Position Color"}
                      suggestionList={suggestions}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FileInput
                      name="photoCopy"
                      placeholder="Upload Image"
                      touched={touched}
                      label="Photo Copy"
                      setFieldValue={(file) => setFieldValue("photoCopy", file)}
                    />
                    <FileInput
                      name="signature"
                      placeholder="Upload Image"
                      label="Signature"
                      setFieldValue={(file) => setFieldValue("signature", file)}
                    />
                  </div>
                </div>

                <div className="memberAddFormRightInputs">
                  {/* Gender Inputs  */}
                  <div className="genderInputs">
                    <ToggleBtn
                      name="gender"
                      type={"radio"}
                      label="Male"
                      value={"male"}
                      setFieldValue={(val) => setFieldValue("gender", val)}
                      errors={errors}
                    />
                    <ToggleBtn
                      name="gender"
                      type={"radio"}
                      label="Female"
                      value={"Female"}
                      setFieldValue={(val) => setFieldValue("gender", val)}
                      errors={errors}
                    />
                    <ToggleBtn
                      name="gender"
                      type={"radio"}
                      label="Others"
                      value={"others"}
                      setFieldValue={(val) => setFieldValue("gender", val)}
                      errors={errors}
                    />
                  </div>
                  <div className="memberAddFormTextInputs">
                    <FormInput
                      type="text"
                      name="name"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your full name"
                      label="Name"
                      setFieldValue={(e) =>
                        setFieldValue("name", e.target.value)
                      }
                    />
                    <FormInput
                      label="Phone No"
                      type="number"
                      name="phone"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your phone number"
                      setFieldValue={(e) =>
                        setFieldValue("phone", e.target.value)
                      }
                    />

                    <FormInput
                      label="Email"
                      type="email"
                      name="email"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your email address"
                      setFieldValue={(e) =>
                        setFieldValue("email", e.target.value)
                      }
                    />
                    <DropDownInput
                      name="designation"
                      label="Designation"
                      setFieldValue={(val) => setFieldValue("designation", val)}
                      placeholder={"Choose designation"}
                      suggestionList={suggestions}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                      touched={touched}
                    />

                    <DatePicker
                      label="Joining Date"
                      name="joiningDate"
                      setFieldValue={(val) => setFieldValue("joiningDate", val)}
                      placeholder={"Choose Joining Date"}
                      errors={errors}
                    />
                    <DropDownInput
                      name="maritalStatus"
                      label="Marital Status"
                      setFieldValue={(val) =>
                        setFieldValue("maritalStatus", val)
                      }
                      placeholder={"Choose Marital Status"}
                      suggestionList={["Married", "Unmarried"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <DropDownInput
                      name="workingField"
                      label="Working field"
                      setFieldValue={(val) =>
                        setFieldValue("workingField", val)
                      }
                      placeholder={"Choose field of work"}
                      suggestionList={["testwork", "test2 work"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FormInput
                      label="Salary"
                      type="number"
                      name="salary"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter monthly pay scale (in INR)"
                      setFieldValue={(e) =>
                        setFieldValue("salary", e.target.value)
                      }
                    />
                    <DropDownInput
                      name="reportingTo"
                      label="Reporting to"
                      setFieldValue={(val) => setFieldValue("reportingTo", val)}
                      placeholder={"Choose supervisor"}
                      suggestionList={["person1", "person2"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <DropDownInput
                      name="bloodGroup"
                      label="Blood group"
                      setFieldValue={(val) => setFieldValue("bloodGroup", val)}
                      placeholder={"Choose your blood group"}
                      suggestionList={[
                        "A+",
                        "A-",
                        "B+",
                        "B-",
                        "O+",
                        "O-",
                        "AB+",
                        "AB-",
                      ]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FormInput
                      type="number"
                      touched={touched}
                      errors={errors}
                      name="experience"
                      label="Experience"
                      setFieldValue={(val) => setFieldValue("experience", val)}
                      placeholder={"Choose year of work experience"}
                    />
                    <DropDownInput
                      name="experienceField"
                      label="Experience field"
                      setFieldValue={(val) =>
                        setFieldValue("experienceField", val)
                      }
                      placeholder={"Choose field of experience"}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                      touched={touched}
                      suggestionList={[
                        "Internship",
                        "Entry Level",
                        "Junior",
                        "Mid-Level",
                        "Senior",
                        "Lead",
                        "Manager",
                        "Director",
                        "Vice President",
                        "C-Level (CEO, CTO, CFO, etc.)",
                      ]}
                    />
                    <FormInput
                      type="text"
                      touched={touched}
                      errors={errors}
                      name="address"
                      label="Address"
                      setFieldValue={(val) => setFieldValue("address", val)}
                      placeholder={"Enter your  full address, with pin"}
                    />
                    <FormInput
                      type="number"
                      touched={touched}
                      errors={errors}
                      name="aadhaarNumber"
                      label="Aadhaar number"
                      setFieldValue={(val) =>
                        setFieldValue("aadhaarNumber", val)
                      }
                      placeholder={"Enter your  aadhaar number"}
                    />
                    <button type="submit" className="memberFormSubmitBtn">
                      Verify
                    </button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </Modal>
      <div className="staffsHeadMemberContainContainer">
        <ul>
          {[...Array(10)].map((data, _key) => {
            return (
              <StaffsHeadCard
                image={profileImg}
                name="Akhil Zabed"
                designation={"Hostel Super"}
              />
            );
          })}{" "}
        </ul>
      </div>

      <div className="membersListSection">
        <div className="memberListContainer">
          <div className="memberListHeader">
            <div className="headerTitleContainer">
              <h3>All members</h3>
              <button
                className="memberAddBtn"
                onClick={() => setAddMemberModal(true)}
              >
                Add Members
              </button>
            </div>
            <div className="membersCountContainer">10 Persons</div>
          </div>

          <div className="memberListContainerSlider">
            <ul className="membersList">
              {[...Array(10)].map((_, index) => (
                <MemberListCard
                  key={index}
                  image={profileImg}
                  name="Md Rejuwanul Karim"
                  profileId="SM0523019"
                  address="Chemistry"
                />
              ))}
            </ul>
          </div>
        </div>

        <div className="indivisualAppearence">
          <div className="memberListHeader">
            <div className="headerTitleContainer">
              <h3>Individual appearance</h3>
              <div className="indivisualMembersCountContainer">10 Persons</div>
            </div>
          </div>
          <div className="indivisualAppearanceTableContainer">
            <table className="indivisualMemberTable">
              <thead>
                <tr>
                  <th>Teachers</th>
                  <th>Subject</th>
                  <th>Percentage</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(10)].map((_, index) => (
                  <IndivisualMemberCard
                    key={index}
                    image={profileImg}
                    name="Md Rejuwanul Karim"
                    profileId="SM0523019"
                    designation="Biology"
                    percentage="30"
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
